class TypeWriter {
  constructor(element, options = {}) {    
    this.element = typeof element === 'string' ? document.querySelector(element) : element;
    this.options = this.parseDataAttributes();
    Object.assign(this.options, options);
    
    this.currentString = 0;
    this.isDeleting = false;
    this.text = '';
    this.timeout = null;
    
    this.init();
  }

  parseDataAttributes() {
    return {
      strings: this.element.dataset.typedStrings ? this.element.dataset.typedStrings.split("~")           : ['Default Text'],
      loop: this.element.dataset.typedLoop !== undefined ? this.element.dataset.typedLoop === 'true'      : true,
      startDelay: this.element.dataset.typedStartDelay ? parseInt(this.element.dataset.typedStartDelay)   : 1000,
      backDelay: this.element.dataset.typedBackDelay ? parseInt(this.element.dataset.typedBackDelay)      : 3000,
      typeSpeed: this.element.dataset.typedTypeSpeed ? parseInt(this.element.dataset.typedTypeSpeed)      : 100,
      backSpeed: this.element.dataset.typedBackSpeed ? parseInt(this.element.dataset.typedBackSpeed)      : 50
    };
  }

  init() {
    if (!this.element || !this.options.strings.length) {
      console.warn('TypeWriter: Invalid element or empty strings array');
      return;
    }

    setTimeout(() => this.tick(), this.options.startDelay);
  }

  tick() {
    const fullString = this.options.strings[this.currentString % this.options.strings.length];
    
    if (this.isDeleting) {
      this.text = fullString.substring(0, this.text.length - 1);
    } else {
      this.text = fullString.substring(0, this.text.length + 1);
    }

    this.element.textContent = this.text;

    let speed = this.isDeleting ? this.options.backSpeed : this.options.typeSpeed;

    if (!this.isDeleting && this.text === fullString) {
      speed = this.options.backDelay;
      this.isDeleting = true;
    } else if (this.isDeleting && this.text === '') {
      this.isDeleting = false;
      this.currentString++;
      
      if (!this.options.loop && this.currentString === this.options.strings.length) {
        return;
      }
      
      speed = this.options.typeSpeed / 2;
    }

    this.timeout = setTimeout(() => this.tick(), speed);
  }

  destroy() {
    clearTimeout(this.timeout);
    this.element.textContent = '';
  }
}

document.addEventListener("DOMContentLoaded", function () {
  // Auto-initialize all elements with data-typed-strings attribute
  document.querySelectorAll('.animation_text_word').forEach(el => {
    // console.log(el);
   new TypeWriter(el);
  });
  
  const videos = document.querySelectorAll(".image-video-inner video,.video-icon-inner video");
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.play();
        } else {
          entry.target.pause();
        }
      });
    },
    { threshold: 0.5 }
  ); // Adjust the threshold as needed

  videos.forEach((video) => observer.observe(video));


  const anim_fadeinup = gsap.utils.toArray(".anim_fadeinup");
  anim_fadeinup.forEach((box, i) => {
    const anim = gsap.fromTo(
      box.children,
      { autoAlpha: 0, y: 50 },
      { delay: 0.2, duration: 1, autoAlpha: 1, y: 0, stagger: 0.25 }
    );
    ScrollTrigger.create({
      trigger: box,
      ease: "power2.inOut",
      animation: anim,
      toggleActions: "play none none none",
      once: false,
    });
  });
  
  var swiper = new Swiper(".testimonial-slider", {
    slidesPerView: 1.3,
    spaceBetween: 10,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 1.3,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2.5,
        spaceBetween: 25,
      },
      1024: {
        slidesPerView: 3.5,
        spaceBetween: 25,
      },
    },
  });

  // Show the first tab by default
  const tabSection = document.querySelectorAll(".collection-tab-wrapper");
  tabSection.forEach((section, index) => {
    const tabsStage = section.querySelectorAll(".tabs-stage>div");
    tabsStage.forEach((tab, index) => {
      tab.style.display = index === 0 ? "block" : "none";
    });
  
    const tabsNav = document.querySelectorAll(".tabs-nav li");
    if (tabsNav.length > 0) {
      tabsNav[0].classList.add("tab-active");
    }
  
    // Change tab class and display content
    section.querySelectorAll(".tabs-nav a").forEach(tab => {
      tab.addEventListener("click", function (event) {
        event.preventDefault();
  
        // Remove active class from all tabs
        tabsNav.forEach(li => li.classList.remove("tab-active"));
        
        // Add active class to the clicked tab
        this.parentElement.classList.add("tab-active");
  
        // Hide all tab content
        tabsStage.forEach(tabContent => (tabContent.style.display = "none"));
  
        // Show the corresponding tab content
        const target = section.querySelector(this.getAttribute("href"));
        if (target) {
          target.style.display = "block";
        }
      });
    });
  });

var swiper = new Swiper(".impact_slider", {
  slidesPerView: 1.5,
  spaceBetween: 0,
  centeredSlides: true,
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  on: {
    slideChange: function () {
      // Remove active class from all slide contents
      document.querySelectorAll(".impact-slider-content").forEach(content => {
        content.classList.remove("active");
      });

      // Add active class to the content of the active slide after 2s
      setTimeout(() => {
        let activeSlide = document.querySelector(".swiper-slide-active .impact-slider-content");
        if (activeSlide) {
          activeSlide.classList.add("active");
        }
      }, 2000);
    }
  }
});

document.querySelectorAll(".footer__block-title").forEach(function (title) {
        title.addEventListener("click", function () {
            this.classList.toggle("active"); // Toggle 'active' class
            let linklist = this.nextElementSibling;

            if (linklist && linklist.classList.contains("footer__linklist")) {
                if (linklist.style.maxHeight) {
                    // Slide up
                    linklist.style.maxHeight = null;
                    linklist.style.removeProperty("margin-top"); // Remove margin
                } else {
                    // Slide down
                    linklist.style.maxHeight = linklist.scrollHeight + "px";
                    linklist.style.setProperty("margin-top", "1rem", "important"); // Add margin with !important
                }
            }
        });
    });

document.querySelectorAll(".popup-dot").forEach(dot => {
  dot.addEventListener("mouseenter", function () {
    // Remove active class from all .featured-dot-content
    document.querySelectorAll(".featured-dot-content").forEach(content => {
      content.classList.remove("active");
    });

    // Add active class only to the hovered one
    this.closest(".featured-dot").querySelector(".featured-dot-content").classList.add("active");

    // Add class to body
    document.body.classList.add("popup-active");
  });

  dot.addEventListener("click", function (event) {
    event.stopPropagation(); // Prevent click from propagating to document

    // Remove active class from all .featured-dot-content
    document.querySelectorAll(".featured-dot-content").forEach(content => {
      content.classList.remove("active");
    });

    // Add active class only to the clicked one
    this.closest(".featured-dot").querySelector(".featured-dot-content").classList.add("active");

    // Add class to body
    document.body.classList.add("popup-active");
  });

  document.addEventListener("click", function (event) {
    // If click happens outside .popup-dot and .featured-dot-content, remove active class and body class
    if (!event.target.closest(".popup-dot") && !event.target.closest(".featured-dot-content")) {
      document.querySelectorAll(".featured-dot-content").forEach(content => {
        content.classList.remove("active");
      });

      document.body.classList.remove("popup-active");
    }
  });
});

// Close icon click event
document.querySelectorAll(".close-icon").forEach(closeBtn => {
  closeBtn.addEventListener("click", function () {
    // Remove active class from all .featured-dot-content
    document.querySelectorAll(".featured-dot-content").forEach(content => {
      content.classList.remove("active");
    });

    // Remove class from body
    document.body.classList.remove("popup-active");
  });
});

  if(document.querySelectorAll('.timeline_slider').length > 0){
var swiper = new Swiper(".timeline_slider", {
  slidesPerView: 1.2,
  spaceBetween: 20,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    640: {
      slidesPerView: 2.2,
      spaceBetween: 30,
    },
    768: {
      slidesPerView: 3.2,
      spaceBetween: 40,
    },
    1024: {
      slidesPerView: 3.5,
      spaceBetween: 63,
    },
  },
});
};

if(document.querySelectorAll('.team_slider').length > 0){
  var swiper = new Swiper(".team_slider", {
    slidesPerView: 1.2,
    spaceBetween: 20,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2.2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3.2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3.5,
        spaceBetween: 30,
      },
    },
  });
};

  var swiper = new Swiper(".ingredient_slider", {
      slidesPerView: 1.2,
      spaceBetween: 16,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
        1199: {
          slidesPerView: 4,
        },
      },
    });


});

document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper !== 'undefined') {
    const carousels = document.querySelectorAll('.ingredient-carousel');

    carousels.forEach((carousel) => {
      new Swiper(carousel, {
        slidesPerView: 5,
        spaceBetween: 20,
        loop: false,
        navigation: {
          nextEl: carousel.parentElement.querySelector('.ingredient-button-next'),
          prevEl: carousel.parentElement.querySelector('.ingredient-button-prev')
        },
        pagination: false,
        breakpoints: {
          768: { slidesPerView: 3 },
          1024: { slidesPerView: 5 }
        }
      });
    });
  } else {
    console.warn('Swiper is not defined');
  }
  
});
document.addEventListener('DOMContentLoaded', function () {
  const headers = document.querySelectorAll('.shopify-section-group-header-group');

  window.addEventListener('scroll', function () {
    headers.forEach(header => {
      if (window.scrollY >= 20) {
        header.classList.add('sticky-header');
      } else {
        header.classList.remove('sticky-header');
      }
    });
  });
});



// --- Firmhouse Variant Sync ---
;(function() {
    function selectVariantById(variantId) {
        const productContainer = document.querySelector('[data-section-type="product"], [data-section-type^="product-template"]'); 
        if (!productContainer) return;

        const productJsonElement = productContainer.querySelector('[data-product-json]');
        if (!productJsonElement) return;
        
        const product = JSON.parse(productJsonElement.textContent);
        const variant = product.variants.find(v => v.id == variantId);
        if (!variant) return;

        let changed = false;
        variant.options.forEach((optionValue, index) => {
            if (optionValue === null) return;
            const optionKey = `option${index + 1}`;
            const selectorsForOption = productContainer.querySelectorAll(`[data-product-option-selector][data-index="${optionKey}"]`);
            if (selectorsForOption.length === 0) return;

            if (selectorsForOption[0].tagName === 'SELECT') {
                if (selectorsForOption[0].value !== optionValue) {
                    selectorsForOption[0].value = optionValue;
                    changed = true;
                }
            } else if (selectorsForOption[0].type === 'radio') {
                selectorsForOption.forEach(radio => {
                    if (radio.value === optionValue && !radio.checked) {
                        radio.checked = true;
                        changed = true;
                    }
                });
            }
        });

        if (changed) {
            const firstSelector = productContainer.querySelector(`[data-product-option-selector]`);
            if (firstSelector) {
                firstSelector.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }
    }

    function updateFirmhouseActiveOption(variantId) {
        document.querySelectorAll('.firmhouse_selling_plan_app_container').forEach(firmhouseBlock => {
            const options = firmhouseBlock.querySelectorAll('.custom-select__option');
            if (!options.length) return;

            options.forEach(option => option.classList.remove('active'));

            const activeOption = firmhouseBlock.querySelector(`.custom-select__option[data-value="${variantId}"]`);
            if (activeOption) {
                activeOption.classList.add('active');
            }
        });
    }

    function hideDefaultVariantPicker(container) {
        const firmhouseBlock = container.querySelector('.firmhouse_selling_plan_app_container');
        if (firmhouseBlock) {
            const variantPicker = container.querySelector('.dbtfy-variant-picker');
            if (variantPicker) {
                variantPicker.style.display = 'none';
            }
        }
    }

    function initFirmhouseIntegration() {
        // Event delegation for radio button changes
        document.body.addEventListener('change', function(event) {
            const target = event.target;
            if (target.matches('.firmhouse_selling_plan_app_container input[type="radio"]')) {
                const variantId = target.dataset.variantId;
                if (variantId) {
                    selectVariantById(variantId);
                    updateFirmhouseActiveOption(variantId);
                }
            }
        });

        // Event delegation for custom div option clicks
        document.body.addEventListener('click', function(event) {
            const customOption = event.target.closest('.custom-select__option');
            if (customOption && customOption.closest('.firmhouse_selling_plan_app_container')) {
                const variantId = customOption.dataset.value;
                if (variantId) {
                    const oneTimePurchaseBlock = customOption.closest('.sales_option_widget__one_time_purchase_option');
                    if (oneTimePurchaseBlock) {
                        const oneTimeRadio = oneTimePurchaseBlock.querySelector('input[data-radio-type="one_time"]');
                        if (oneTimeRadio && !oneTimeRadio.checked) {
                            oneTimeRadio.checked = true;
                        }
                        const hiddenSelect = oneTimePurchaseBlock.querySelector('.sales_option_widget__variant_select');
                        if (hiddenSelect && hiddenSelect.value !== variantId) {
                            hiddenSelect.value = variantId;
                        }
                    }
                    selectVariantById(variantId);
                    updateFirmhouseActiveOption(variantId);
                }
            }
        });
        
        // Listen for the theme's variantChange event to sync the active state to the Firmhouse UI
        document.body.addEventListener('variantChange', function(event) {
            if (event.detail && event.detail.variant) {
                updateFirmhouseActiveOption(event.detail.variant.id);
            }
        });

        // Initial check on all sections
        document.querySelectorAll('[data-section-id]').forEach(section => {
            hideDefaultVariantPicker(section);
        });

        // Set initial active state based on current variant
        const productContainer = document.querySelector('[data-section-type="product"], [data-section-type^="product-template"]');
        if (productContainer) {
            const masterSelect = productContainer.querySelector('[data-product-master-select]');
            if (masterSelect && masterSelect.value) {
                updateFirmhouseActiveOption(masterSelect.value);
            }
        }
    }

    // Run on initial page load
    if (document.readyState === 'loading') {
        window.addEventListener('DOMContentLoaded', initFirmhouseIntegration);
    } else {
        initFirmhouseIntegration();
    }
    
    // Also run on section load for theme editor compatibility
    document.addEventListener('shopify:section:load', function(event) {
        const firmhouseContainer = event.target.querySelector('.firmhouse_selling_plan_app_container');
        if (firmhouseContainer) {
            hideDefaultVariantPicker(event.target);
            const masterSelect = event.target.querySelector('[data-product-master-select]');
            if (masterSelect && masterSelect.value) {
                updateFirmhouseActiveOption(masterSelect.value);
            }
        }
    });
})();